import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    drawer: {
      width: 550,
    },
    header: {
      backgroundColor: theme.gray50,
      display: "flex",
      justifyContent: "space-between",
      "& > div": {
        display: "flex",
      },
    },
    title: {
      fontWeight: 500,
      overflow: "hidden",
      textOverflow: "ellipsis",
      textWrap: "nowrap",
      padding: theme.spacing(6, 8),
    },
    closeIcon: {
      cursor: "pointer",
      margin: theme.spacing(6, 8),
    },
    markAsRead: {
      color: theme.primary500,
      cursor: "pointer",
      marginLeft: "auto",
      padding: theme.spacing(6, 0, 6, 0),
    },
    content: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      gap: theme.spacing(4),
      padding: theme.spacing(8),
    },
    detailsBox: {
      alignItems: "center",
      backgroundColor: theme.gray50,
      borderRadius: "8px",
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      gap: theme.spacing(12),
      padding: theme.spacing(8),
      position: "relative",
    },
    unreadNews: {
      "&::before": {
        background: theme.primary500,
        border: `1px solid ${theme.primary500}`,
        borderRadius: "2px 0 0 2px",
        content: "''",
        height: "100%",
        left: 0,
        position: "absolute",
        top: 0,
        width: theme.spacing(3),
      },
    },
    btnContainer: {
      backgroundColor: theme.white00,
      borderTop: `1px solid ${theme.gray100}`,
      bottom: 0,
      display: "flex",
      justifyContent: "end",
      marginTop: "auto",
      padding: theme.spacing(6, 8),
      position: "sticky",
      right: 0,
      width: "100%",
      zIndex: 3,
    },
    headerContainer: {
      alignItems: "start",
      display: "flex",
      gap: theme.spacing(4),
      height: "100%",
    },
    smallText: {
      color: theme.gray800,
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "24px",
    },
    icon: {
      color: theme.primary500,
      height: "24px",
      minWidth: "24px",
    },
    externalIcon: {
      height: "16px",
      minWidth: "16px",
    },
    newsContent: {
      display: "flex",
      gap: theme.spacing(2),
      flexDirection: "column",
    },
    newsHeader: {
      display: "flex",
      gap: theme.spacing(5),
      flexWrap: "nowrap",
      justifyContent: "space-between",
    },
    newsTitle: {
      color: theme.gray800,
      fontWeight: 500,
    },
    newsDate: {
      color: theme.gray500,
      fontWeight: 300,
      textWrap: "nowrap",
    },
    descPurple: {
      fontSize: 14,
      marginLeft: theme.spacing(2),
      width: "fit-content",
    },
    flexWrapper: {
      display: "flex",
      alignItems: "center",
    },
    item: {
      color: theme.gray500,
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "400",
      minWidth: "20px",
      padding: 0,
      textDecoration: "none",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "inherit",
        color: theme.gray500,
      },
      "& span": {
        marginLeft: 0,
      },
    },
    animatedIcon: {
      height: "30px",
      width: "30px",
      position: "relative",
    },
    notificationDot: {
      "&::after": {
        backgroundColor: theme.red500,
        borderRadius: "50%",
        content: '""',
        height: "6px",
        position: "absolute",
        right: "8px",
        top: "7px",
        width: "6px",
      },
    },
    hiddenOverflow: {
      overflow: "hidden",
    },
    ellipsisText: {
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    },
  }),
);
